import { makeAutoObservable } from 'mobx'
import dayjs, { Dayjs } from 'dayjs'
import { ISettingDB } from '../models/ISetting'
import { TFilterNumberType } from '../containers/tableMakersType'

export default class SettingStore {
  isLoading: boolean = false
  industry: string = ''
  totalSum: number = 0
  country: string = ''
  name: string=''
  region: string[] = []
  year: Dayjs | null = dayjs()
  selectedRowKeys: React.Key[] = []
  selectedRowKeysRoles: React.Key[] = []
  companiesData: ISettingDB[] | [] = []
  rev: TFilterNumberType = {
    start: 0,
    end: 5000000,
  }
  mark: TFilterNumberType = {
    start: 0,
    end: 5000000,
  }
  targetRoles: string[] = []

  constructor() {
    makeAutoObservable(this)
  }
  setLoading(bool: boolean) {
    this.isLoading = bool
  }
  setIndustry(data: string) {
    this.industry = data
  }
  setTotalSum(data: number) {
    this.totalSum = data
  }
  setCountry(data: string) {
    this.country = data
  }
  setRegion(data: string[]) {
    this.region = data
  }
  setYear(data: Dayjs | null) {
    this.year = data
  }
  setSelectedRowKeys(data: React.Key[]) {
    this.selectedRowKeys = data
  }
  setCompaniesData(data: ISettingDB[]) {
    this.companiesData = data
  }
  setMark(data: TFilterNumberType) {
    this.mark = data
  }
  setRev(data: TFilterNumberType) {
    this.rev = data
  }
  setName(data: string) {
    this.name = data
  }
  setTargetRoles(data: string[]){
    this.targetRoles = data
  }
  setSelectedRowKeysRoles
  (data: React.Key[]){
    this.selectedRowKeysRoles = data
  }
}
